import { useEffect, useState, useCallback } from 'react'
import moment from 'moment';
import { Button, Col, DatePicker, Form, Input, InputNumber, message, Row, Select } from 'antd';
import { getTaxableInvoiceApi, getTaxSummaryApi, getInvoicesTypesApi } from '../../utils/apisConsts';
import { ModalComponent, ReusableDataTable, PdfComponent } from '@operations/shared';
import TaxInvoiceView from './TaxInvoiceView';
import { request } from "../../../../shared/src/apis";
import { useDispatch } from 'react-redux';
import helper from '../../utils/helper';
import { InvoiceType, TaxableInvoicesFilters } from '../../utils/commonInterfaces';
const { RangePicker } = DatePicker;

export const InvoicesTable = () => {
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
    const [loadingId, setLoadingId] = useState<string | null>(null);
    const [companies, setCompanies] = useState<any>();
    const [isCompaniesLoading, setisCompaniesLoading] = useState<boolean>();
    const [canResetFilter, setCanResetFilter] = useState<boolean>(false);
    const [invoicesTypes, setInvoicesTypes] = useState<any>(null)
    const [filters, setFilters] = useState<TaxableInvoicesFilters>({});
    const [apiUrl, setApiUrl] = useState(getTaxableInvoiceApi);
    const dispatch = useDispatch()
    const [form] = Form.useForm();
    const dateFormat = "YYYY/MM/DD";

    useEffect(() => {
        const getCompanies = async () => {
            try {
                setisCompaniesLoading(true)
                const companiesRes: any = await helper.getAllCompanies()
                if (companiesRes?.status === 200) {
                    setCompanies(companiesRes?.data)
                    setisCompaniesLoading(false)
                }
                else {
                    message.error("Something went wrong, please try again later.")
                }
            }
            catch (error) {
                console.log(error)
                message.error("Something went wrong, please try again later.")
            }
        }

        getCompanies()
    }, [])

    useEffect(() => {
        const query = new URLSearchParams();

        Object.entries(filters).forEach(([key, value]) => {
            if (value) {
                query.append(key, value);
            }
        });
        
        const fullUrl = `${getTaxableInvoiceApi}?${query.toString()}`;
        setApiUrl(fullUrl);
    }, [filters]);

    const getInvoicesTypes = useCallback(async () => {
        try {
            const response: any = await dispatch(request({
                url: `${getInvoicesTypesApi}`,
                method: 'GET'
            }));
            setInvoicesTypes(response?.data?.data);
        } catch (error) {
            console.error('Failed to fetch invoice Types:', error);
        } finally {
            setLoadingId(null);
        }
    }, [dispatch])

    useEffect(() => {
        getInvoicesTypes()
    }, [getInvoicesTypes])

    const handleOpenModal = async (row: any) => {
        const invoiceId = row?.creditSerialNumber ?? row?.invoiceSerialNumber;
        setLoadingId(invoiceId);
        try {
            const response: any = await dispatch(request({
                url: `${getTaxSummaryApi}/${row?.creditSerialNumber ?? row?.invoiceSerialNumber}`,
                method: 'GET'
            }));
            console.log(response)
            setSelectedInvoice(response?.data?.data);

            setIsOpenModal(true);
        } catch (error) {
            console.error('Failed to fetch invoice:', error);
        } finally {
            setLoadingId(null);
        }
    }
    const handleCloseModal = () => {
        setIsOpenModal(false);
    }
    let columns = [
        ...(filters?.invoiceType === InvoiceType.B2C_INVOICE || !filters?.invoiceType ? [{
            title: (
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                    User ID
                </span>
            ),
            dataIndex: 'userID',
            key: 'userID',
            align: 'center' as const,
            render: (_: any, row: any) => (
                <span style={{
                    fontWeight: 600,
                    color: '#2c3e50',
                    fontSize: '14px'
                }}>
                    {row?.userID ?? 'N/A'}
                </span>
            )
        },
        ] : []),
        {
            title: (
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                    Serial Number
                </span>
            ),
            dataIndex: 'invoiceSerialNumber',
            key: 'invoiceSerialNumber',
            align: 'center' as const,
            render: (_: any, row: any) => (
                <span style={{
                    fontWeight: 600,
                    color: '#2c3e50',
                    fontSize: '14px'
                }}>
                    {row?.creditSerialNumber ?? row?.invoiceSerialNumber}
                </span>
            )
        },
        {
            title: (
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                    Customer
                </span>
            ),
            dataIndex: 'invoiceSerialNumber',
            key: 'invoiceSerialNumber',
            align: 'center' as const,
            render: (_: any, row: any) => (
                <span style={{ 
                    fontWeight: 600, 
                    color: '#2c3e50',
                    fontSize: '14px'
                }}>
                    {row?.invoiceTypeID === InvoiceType.B2C_INVOICE ? row?.userName : row?.companyName ?? 'N/A'}
                </span>
            )
        },
        {
            title: (
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                    Type
                </span>
            ),
            dataIndex: 'taxableInvoicesTypeName',
            key: 'taxableInvoicesTypeName',
            align: 'center' as const,
            render: (_: any, row: any) => (
                <span style={{ 
                    fontWeight: 600, 
                    color: '#2c3e50',
                    fontSize: '14px'
                }}>
                    {row?.taxableInvoicesTypeName ?? 'N/A'}
                </span>
            )
        },
        {
            title: (
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                    Issue Date
                </span>
            ),
            dataIndex: 'issueDate',
            key: 'issueDate',
            align: 'center' as const,
            render: (row: any) => (
                <span style={{
                    color: '#555',
                    fontWeight: 500
                }}>
                    {moment(row).format('LL')}
                </span>
            )
        },
        {
            title: (
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                    Total Value
                </span>
            ),
            dataIndex: 'total',
            key: 'total',
            align: 'center' as const,
            render: (_: any, row: any) => (
                <span style={{
                    fontWeight: 600,
                    fontSize: '15px',
                    color: '#2c3e50'
                }}>
                    {row?.total} SAR
                </span>
            ),
        },
        {
            title: (
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                    Invoice
                </span>
            ),
            dataIndex: 'download',
            key: 'download',
            align: 'center' as const,
            render: (_: any, row: any) => {
                const invoiceId = row?.creditSerialNumber ?? row?.invoiceSerialNumber;
                const isLoading = loadingId === invoiceId;
                const isDisabled = loadingId !== null && !isLoading;

                return (
                    <Button
                        type="primary"
                        loading={isLoading}
                        disabled={isDisabled}
                        onClick={() => handleOpenModal(row)}
                        style={{
                            width: '110px',
                            background: 'linear-gradient(135deg, #434343 0%, #000000 100%)',
                            border: 'none',
                            borderRadius: '8px',
                            fontWeight: 600,
                            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
                            transition: 'all 0.3s ease',
                            color: '#fff'
                        }}
                    >
                        View
                    </Button>
                );
            }
        },
    ];

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <div
                    style={{
                        textAlign: "center",
                        marginBottom: "30px",
                        paddingBottom: "15px",
                        borderBottom: "2px solid #ddd"
                    }}
                >
                    <h2
                        style={{
                            fontSize: "28px",
                            fontWeight: 700,
                            margin: "0",
                            color: "#2c3e50",
                            letterSpacing: "0.5px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "12px"
                        }}
                    >
                        Taxable Invoices
                    </h2>
                </div>
                <Form
                    name="basic"
                    autoComplete="off"
                    form={form}
                >
                    <Row className="statusRow" gutter={[16, 16]}>
                        <Col md={6}>
                            <label htmlFor="">Type </label>
                            <Form.Item name="Type" >
                                <Select style={{ width: "100%" }} placeholder="Select Type" showSearch allowClear
                                    filterOption={((input, option: any) => helper.dropDownSearch(input, option))}
                                >
                                    {
                                        Array.isArray(invoicesTypes) &&
                                        invoicesTypes.map((type: any, key: any) => {
                                            return <Select.Option value={type?.id} key={key}>{type?.name}</Select.Option>
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col md={6}>
                            <label htmlFor="">Date </label>
                            <Form.Item name="dateRange">
                                <RangePicker format={dateFormat} style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col md={6}>
                            <label htmlFor="">Serial Number </label>
                            <Form.Item name="Number">
                                <Input placeholder="Search by Serial Number" style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col md={6}>
                            <label htmlFor="">Company </label>
                            <Form.Item name="Company" >
                                <Select style={{ width: "100%" }} placeholder="Select Company" showSearch allowClear
                                    filterOption={((input, option: any) => helper.dropDownSearch(input, option))}
                                    loading={isCompaniesLoading}
                                >
                                    {
                                        Array.isArray(companies) &&
                                        companies.map((company: any, key: any) => {
                                            return <Select.Option value={company?.id} key={key}>{company?.name}</Select.Option>
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col md={6}>
                            <label htmlFor="">User </label>
                            <Form.Item
                                name="user"
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (value === 0) {
                                                return Promise.reject(new Error('User cannot be 0'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <InputNumber placeholder="Search by user" style={{ width: '100%' }} min={0} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row className="statusRow" style={{ float: "right", marginBottom: "16px" }} gutter={[16, 16]}>
                        <Col style={{ float: "right" }}>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ width: "110px", background: "linear-gradient(135deg, rgb(67, 67, 67) 0%, rgb(0, 0, 0) 100%)", border: 'none', borderRadius: "8px", fontWeight: 600, boxShadow: "rgba(0, 0, 0, 0.3) 0px 4px 15px", transition: "0.3s", color: "rgb(255, 255, 255)" }}
                                    onClick={() => {
                                        const values = form.getFieldsValue();

                                        const parsedFilters = {
                                            invoiceType: values.Type || undefined,
                                            invoiceNumber: values.Number || undefined,
                                            userID: values.user || undefined,
                                            companyID: values.Company || undefined,
                                            startDate: values.dateRange?.[0] || undefined,
                                            endDate: values.dateRange?.[1] || undefined,
                                        };

                                        setFilters(parsedFilters);
                                        const hasFilters = Object.values(parsedFilters).some(filter => filter !== undefined);
                                        setCanResetFilter(hasFilters);
                                    }}
                                >
                                    Search
                                </Button>
                            </Form.Item>
                        </Col>
                        {canResetFilter && <Col style={{ float: "right" }}>
                            <Form.Item>
                                <Button
                                    style={{ borderRadius: "8px" }}
                                    onClick={() => {
                                        form?.resetFields();
                                        setFilters({});
                                        setCanResetFilter(false);
                                    }} danger>
                                    Clear filter
                                </Button>
                            </Form.Item>
                        </Col>}
                    </Row>
                </Form>
                <ReusableDataTable 
                    key={apiUrl} columns={columns} hiddenRefreshing apiLink={apiUrl}
                    pagination={{}} loading={false} scrolling={{ x: 'fit-content' }} loadData={true}
                />
            </div>
            <ModalComponent
                content={<PdfComponent fileName={`${selectedInvoice?.creditSerialNumber ?? selectedInvoice?.invoiceSerialNumber}_${InvoiceType.B2C_INVOICE === selectedInvoice?.invoiceTypeID ? selectedInvoice?.userName : selectedInvoice?.to}_${moment().format('YYYY-MM-DD')}`} content={<TaxInvoiceView invoiceData={selectedInvoice} />} />}
                title={`Tax Invoice`}
                visibleModal={isOpenModal}
                handleCloseModal={() => handleCloseModal()}
                handleAcceptModal={() => handleCloseModal()} />
        </>
    )
}
